import React, { useState, useEffect, useRef } from "react";
import "../css/SendEmails.css";
import axios from "axios";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
    generateInvitePassword,
    getOrCreateInvitePassword,
    normalizePersonId,
} from "../../utils/invitePasswordCache";

const SendEmails = () => {
    const API_URL = process.env.REACT_APP_API_URL;

    const [activeTab, setActiveTab] = useState("individual");
    const [individualSelected, setIndividualSelected] = useState([]);
    const [groupSelected, setGroupSelected] = useState({});
    const [groupMembersSelected, setGroupMembersSelected] = useState([]);
    const [persons, setPersons] = useState([]);
    const [groupsMap, setGroupsMap] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});
    const [searchIndividuals, setSearchIndividuals] = useState("");
    const [searchGroups, setSearchGroups] = useState("");
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [activeCompetitionId, setActiveCompetitionId] = useState(null);
    const [rawTemplateBody, setRawTemplateBody] = useState("");


    const [orgEmail, setOrgEmail] = useState("");

    const [editorHtml, setEditorHtml] = useState("");
    const [plainPasswords, setPlainPasswords] = useState({});
    const [organisations, setOrganisations] = useState({});
    const [personRoles, setPersonRoles] = useState([]);
    const [competitions, setCompetitions] = useState([]);
    const [editablePreviews, setEditablePreviews] = useState({});
    const quillRef = useRef(null);
    const editorRef = useRef(null);

    const [fromName] = useState("IGF Team");
    const [fromEmail] = useState("tnaparna174@gmail.com");

    const [placeholders] = useState([
        "{{name}}",
        "{{email}}",
        "{{phone}}",
        // "{{competition}}",
        "{{password}}"
    ]);

    const [formData, setFormData] = useState({
        name: "",
        subject: "",
        body: "",
        files: [],
        group_id: "",
        competition_id: "",
    });

    // Convert Organisation Name → Organisation Email (OPTION B)
    const orgNameToEmail = (name) => {
        if (!name) return "-";
        const clean = name.toLowerCase().replace(/[^a-z0-9]/g, "");
        return `info@${clean}.org`;
    };

    const getOrganisationName = (personId, orgMap, roles) => {
        if (!personId || !roles.length) return "-";
        const relations = roles.filter((role) => role.person_id === personId);
        const orgNames = relations.map((relation) => orgMap[relation.org_id]).filter(Boolean).join(", ");
        return orgNames || "N/A";
    };

    const determineOrganisationEmail = (recipient) => {
        if (!recipient || !recipient.organisation) return "";
        const email = orgNameToEmail(recipient.organisation);
        return email;
    };

    // New utility function to get full person details for group members display
    const getGroupMemberDetails = (personId) => {
        return persons.find(p => p._id === personId);
    };

    const safeParsePersonData = (rawData) => {
        if (!rawData) return {};

        let processed = rawData;

        while (typeof processed === "string") {
            try {
            const parsed = JSON.parse(processed);

            // Handle {"0":"{","1":"\""} corruption
            if (parsed && typeof parsed === "object" && parsed["0"] === "{") {
                processed = Object.values(parsed).join("");
            } else {
                processed = parsed;
            }
            } catch {
            return {};
            }
        }

        return typeof processed === "object" ? processed : {};
        };


    // Fetch templates
    const fetchCompetitions = async () => {
        try {
            const res = await axios.get(
            `${API_URL}/ems/competitions?active=true`
            );

            const data =
            res.data?.data ||
            res.data?.competitions ||
            res.data;

            setCompetitions(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Failed to fetch competitions", err);
        }
        };
    useEffect(() => {
        fetchCompetitions();
    }, [API_URL]);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const res = await axios.get(`${API_URL}/ems/templates`);
                setTemplates(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error("Failed to fetch templates", err);
            }
        };
        fetchTemplates();
    }, [API_URL]);

    // Keep preview updated for selected template
    

    // Fetch participant + org + roles
    useEffect(() => {
        const fetchParticipants = async () => {
            try {
                const [participantsRes, orgRes, personRolesRes] = await Promise.all([
                    axios.get(`${API_URL}/ems/participants`, { params: { slim: true } }),
                    axios.get(`${API_URL}/organisations`),
                    axios.get(`${API_URL}/personRoles`)
                ]);

                const data = participantsRes.data?.data ||
                    participantsRes.data?.participants ||
                    participantsRes.data ||
                    [];

                const personRolesData = personRolesRes.data;
                setPersonRoles(personRolesData);

                const orgMap = orgRes.data.reduce((map, org) => {
                    map[org._id] = org.name;
                    return map;
                }, {});
                setOrganisations(orgMap);

                const newPlainPasswords = {};
                const uniquePersonsMap = {};
                const newGroupsMap = {};

                data.forEach((p) => {
                    if (p.person_id) {
                        const personId = normalizePersonId(p.person_id._id);
                        if (!personId) return;
                        const meta = p.person_data ? safeParsePersonData(p.person_data) : {};

                        const firstName = meta.givenFirstName || p.person_id.name || "";
                        const lastName = meta.familyLastName || p.person_id.lname || "";
                        const fullName = ` ${firstName} ${lastName}`.trim();

                        if (!newPlainPasswords[personId]) {
                            // Same password as Participant Edit (localStorage cache per person)
                            newPlainPasswords[personId] = getOrCreateInvitePassword(
                                personId,
                                generateInvitePassword
                            );
                        }
                        const plainPassword = newPlainPasswords[personId];


                        let groupNames = [];
                        let groupIds = [];
                        if (p.group_id) {
                            const groupsToCheck = Array.isArray(p.group_id) ? p.group_id : [p.group_id];
                            
                            groupsToCheck.forEach((group) => {
                                const gId = group._id;
                                if (!newGroupsMap[gId]) {
                                    newGroupsMap[gId] = {
                                        groupId: gId,
                                        group_name: group.group_name,
                                        persons: [],
                                    };
                                }
                                
                                const orgEmailClean = orgNameToEmail(getOrganisationName(personId, orgMap, personRolesData));

                                // Prevent duplicate person entries in the group's person list
                                if (!newGroupsMap[gId].persons.some(member => member.personId === personId)) {
                                    newGroupsMap[gId].persons.push({
                                        personId: personId,
                                        name: `${fullName} - ${orgEmailClean}`, 
                                    });
                                }
                                groupNames.push(group.group_name);
                                groupIds.push(gId);
                            });
                        }
                        
                        if (!uniquePersonsMap[personId]) {
                            const orgName = getOrganisationName(personId, orgMap, personRolesData);
                            const orgEmailClean = orgNameToEmail(orgName);

                            uniquePersonsMap[personId] = {
                                _id: personId,
                                firstName: firstName, 
                                lastName: lastName, 
                                fullName: fullName,
                                email: p.person_id.email,
                                organisation: orgName, 
                                organisationEmail: orgEmailClean, 
                                group: groupNames.length > 0 ? groupNames.join(", ") : "-",
                                groupIds: groupIds, // Keep track of associated group Ids
                                generatedPassword: plainPassword,
                            };
                        }
                    }
                });

                setPersons(Object.values(uniquePersonsMap));
                setPlainPasswords(newPlainPasswords);
                setGroupsMap(newGroupsMap);
            } catch (err) {
                console.error("Failed to fetch participants", err);
            }
        };

        fetchParticipants();
    }, [API_URL]);


    useEffect(() => {
    const recipients = getRecipientsForPreview();
    const newPreviews = { ...editablePreviews };

    recipients.forEach(person => {
        const personId = normalizePersonId(person._id);
        // Keep same cached plain password for send; do not show it in editor
        getOrCreateInvitePassword(personId, generateInvitePassword);
        newPreviews[personId] = replacePlaceholders(rawTemplateBody, person, "", {
            hidePassword: true,
        });
    });

    setEditablePreviews(newPreviews);
}, [rawTemplateBody, individualSelected, groupMembersSelected, plainPasswords]);

    // Derived State for filtering
    const allGroupMembersIds = Object.values(groupsMap).flatMap(g => g.persons.map(p => p.personId));
    const allGroupMembers = persons.filter(p => allGroupMembersIds.includes(p._id));

    const filteredIndividuals = persons.filter((p) => {
        const s = (searchIndividuals || "").toLowerCase();
        return (
            (p.fullName || "").toLowerCase().includes(s) ||
            (p.email || "").toLowerCase().includes(s) ||
            (p.group || "").toLowerCase().includes(s)
        );
    });

    const filteredGroupMembersList = allGroupMembers.filter((p) => {
        const s = (searchGroups || "").toLowerCase();
        return (
            (p.fullName || "").toLowerCase().includes(s) ||
            (p.email || "").toLowerCase().includes(s) ||
            (p.group || "").toLowerCase().includes(s)
        );
    });

    // Filtering logic for the nested group display (old behavior, kept for `filteredGroups` calculation)
    const filteredGroups = Object.values(groupsMap).filter((g) => {
        const s = (searchGroups || "").toLowerCase();
        return (
            (g.group_name || "").toLowerCase().includes(s) ||
            g.persons.some((p) => {
                const member = getGroupMemberDetails(p.personId);
                if (!member) return false;
                return (
                    (member.fullName || "").toLowerCase().includes(s) ||
                    (member.email || "").toLowerCase().includes(s)
                );
            })
        );
    });
    
    // --- Handlers for Individuals Tab ---

    const handleSelectAllIndividuals = () => {
        const allPersonIds = filteredIndividuals.map((p) => p._id);
        setIndividualSelected(allPersonIds);
    };

    const handleDeselectAllIndividuals = () => {
        setIndividualSelected([]);
    };

    const handleIndividualCheckboxChange = (id) => {
        setIndividualSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // --- Handlers for Groups Tab (Flat List Logic) ---
    
    // 🌟 MODIFIED: Select all visible group members
    const handleSelectAllGroups = () => {
        // Use the filtered flat list of members
        const allVisibleGroupPersonIds = filteredGroupMembersList.map((p) => p._id);
        setGroupMembersSelected((prev) => 
            Array.from(new Set([...prev, ...allVisibleGroupPersonIds]))
        );
        // Clear secondary group selection map as it's not the primary selection method here
        setGroupSelected({});
    };

    // 🌟 MODIFIED: Deselect all visible group members
    const handleDeselectAllGroups = () => {
        // Get IDs of persons currently visible in the filtered list
        const visiblePersonIds = filteredGroupMembersList.map((p) => p._id);
        
        // Deselect only the visible persons from the total selection
        setGroupMembersSelected((prev) => 
            prev.filter((id) => !visiblePersonIds.includes(id))
        );
        // Clear secondary group selection map
        setGroupSelected({});
    };

    // 🌟 MODIFIED: Group Member Change handler is now the primary interaction
    const handleGroupMemberChange = (id) => {
        setGroupMembersSelected((prev) => {
            const isSelected = prev.includes(id);
            let newSelection = isSelected ? prev.filter((x) => x !== id) : [...prev, id];

            // NOTE: Logic for updating groupSelected state based on individual selection 
            // is complex and potentially confusing in a flat list view, so we'll 
            // simplify it and leave groupSelected as an empty object in this implementation 
            // if we are fully switching to the flat list of members.
            // Keeping the original logic commented out just in case the user wants it back:
            /*
            const updatedGroupSelected = { ...groupSelected };
            Object.entries(groupsMap).forEach(([groupId, group]) => {
                 const groupMembers = group.persons.map((p) => p.personId);
                 const membersSelectedCount = groupMembers.filter((memberId) =>
                     newSelection.includes(memberId)
                 ).length;

                 if (membersSelectedCount === groupMembers.length && groupMembers.length > 0) {
                     updatedGroupSelected[groupId] = true;
                 } else if (membersSelectedCount === 0) {
                     delete updatedGroupSelected[groupId];
                 }
            });
            setGroupSelected(updatedGroupSelected);
            */

            return newSelection;
        });
    };
    

    const handleGroupNameChange = (groupId) => {
        const isSelected = !groupSelected[groupId];
        setGroupSelected((prev) => ({ ...prev, [groupId]: isSelected }));

        const members = groupsMap[groupId]?.persons.map((p) => p.personId) || [];
        setGroupMembersSelected((prev) => {
            if (isSelected) return Array.from(new Set([...prev, ...members]));
            return prev.filter((id) => !members.includes(id));
        });
    };

    const toggleGroupExpand = (groupId) => {
        setExpandedGroups((prev) => ({ ...prev, [groupId]: !prev[groupId] }));
    };

    // --- Utility Functions ---

    const getRecipientsForPreview = () => {
            const allIds = [...individualSelected, ...groupMembersSelected];
            const uniqueIds = Array.from(new Set(allIds));
            return persons.filter(p => uniqueIds.includes(p._id));
            };

    // ✅ DERIVED PREVIEW DATA (AUTO-UPDATES)
    

    // Preview: keep {{password}} (never show plain). Send: inject plain; server stores bcrypt hash.
    const replacePlaceholders = (templateBody, person, password, { hidePassword = false } = {}) => {
    if (!templateBody) return "";

    let html = templateBody
        .replace(/{{name}}/g, person?.fullName || "")
        .replace(/{{email}}/g, person?.email || "")
        .replace(/{{phone}}/g, person?.phone || "")
        .replace(/{{competition}}/g, person?.competition || "");
    if (!hidePassword) {
        html = html.replace(/{{password}}/g, password || "");
    }
    return html;
};

    const recipientsForPreview = getRecipientsForPreview();

    const previewHtmlList = getRecipientsForPreview().map(person => {
    const personId = normalizePersonId(person._id);
    getOrCreateInvitePassword(personId, generateInvitePassword);
    return {
        personId,
        name: person.fullName,
        html:
            editablePreviews[personId] ||
            replacePlaceholders(rawTemplateBody, person, "", { hidePassword: true }),
    };
});



    const handleTemplateChange = (e) => {
    const templateId = e.target.value;
    setSelectedTemplate(templateId);

    const chosen = templates.find((t) => t._id === templateId);
    if (!chosen) {
        setEditorHtml("");
        setFormData(prev => ({ ...prev, subject: "" }));
        return;
    }

    const templateBody = chosen.body || chosen.templateBody || chosen.content || "";
    setRawTemplateBody(templateBody);   // store raw template
    setEditorHtml(templateBody);        // editor content
    setFormData(prev => ({ ...prev, subject: chosen.subject || "" })); // ✅ populate subject
};


    const insertPlaceholder = (ph) => {
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();

        if (range) {
            editor.insertText(range.index, ph);
        } else {
            editor.insertText(editor.getLength(), ph);
        }
    };
    const insertPlaceholderIntoPreview = (personId, placeholder) => {
    const currentContent = editablePreviews[personId] || "";
    // This appends the placeholder to the end of the current content
    // If you want exact cursor placement, it requires a more complex ref-per-id setup
    const newContent = currentContent + placeholder;
    
    setEditablePreviews(prev => ({
        ...prev,
        [personId]: newContent
    }));
};
    const getAllRecipients = () => {
    const allSelectedIds = [...individualSelected, ...groupMembersSelected];

    const uniqueIds = Array.from(new Set(allSelectedIds));
    
    console.log("Attempting to find IDs in persons array:", uniqueIds);

    return persons.filter(p => uniqueIds.map(String).includes(String(p._id)));
};


//     const getRawTemplateBody = () => {
//   const tpl = templates.find(t => t._id === selectedTemplate);
//   return tpl?.body || "";
// };


    const handleSubmit = async (e) => {
    e.preventDefault();

    const recipients = getAllRecipients();
    if (!recipients.length) return alert("Select recipients");
    if (!formData.subject) return alert("Subject required");

    const payload = recipients.map((p) => {
        const personId = normalizePersonId(p._id);
        const plainPassword =
            getOrCreateInvitePassword(personId, generateInvitePassword) ||
            plainPasswords[personId];
        const bodyContent = editablePreviews[personId] || editablePreviews[p._id] || rawTemplateBody;

        return {
            personId,
            subject: formData.subject,
            body: replacePlaceholders(bodyContent, p, plainPassword),
            from_name: fromName,
            email: fromEmail,
            plainPassword,
        };
    });

    try {
        await axios.post(`${API_URL}/ems/send-emails`, {
            from_name: fromName,
            email: fromEmail,
            emails: payload,
        });

        alert("Emails sent successfully");
    } catch (err) {
        console.error(err);
        alert("Email sending failed");
    }
};


    // Total Recipient Count
    const selectedRecipientCount = getAllRecipients().length;

    return (
        <div className="send-email-container">
            <h4>Send Email</h4>

            {/* Template Selection */}
            <div className="mb-4">
                <label className="form-label">Choose Template</label>
                <select
                    className="form-select"
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                >
                    <option value="">-- Select a template --</option>
                    {templates.map((t) => (
                        <option key={t._id} value={t._id}>
                            {t.name}
                        </option>
                    ))}
                </select>
            </div>

            <form onSubmit={handleSubmit}>
               
                
                {/* ... inside your return statement ... */}

{selectedTemplate && (
    <div>
        
        {/* The Master Editor */}
        
        

        {/* --- IMPROVED PREVIEW SECTION --- */}
        {/* --- IMPROVED PREVIEW SECTION --- */}
{previewHtmlList.length > 0 && (
    <div className="mt-4">
        {/* <h5 className="mb-3">Email Previews ({previewHtmlList.length})</h5> */}
        
        {previewHtmlList.map(p => (
            <div key={p.personId} className="card mb-4 border-secondary">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="placeholder-tools">
                        {placeholders.map(ph => (
                            <button
                                key={ph}
                                type="button"
                                className="btn btn-xs me-1"
                                style={{ fontSize: '13px', padding: '2px 5px' }}
                                onClick={() => insertPlaceholderIntoPreview(p.personId, ph)}
                            >
                                {ph}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="card-body p-0">
                    <ReactQuill
                        theme="snow"
                        value={editablePreviews[p.personId] || ""}
                        onChange={(content) => {
                            setEditablePreviews(prev => ({
                                ...prev,
                                [p.personId]: content
                            }));
                        }}
                        placeholder="Customize this email..."
                        style={{ height: "200px", marginBottom: "40px" }}
                    />
                </div>
            </div>
        ))}
    </div>
)}
    </div>
)}

                <div className="tab-toggle mb-3">
                    <button
                        type="button"
                        className={`btn ${
                            activeTab === "individual" ? "btn-secondary" : "btn-dark"
                        }`}
                        onClick={() => setActiveTab("individual")}
                    >
                        Individuals 
                    </button>
                    <button
                        type="button"
                        className={`btn ${
                            activeTab === "group" ? "btn-secondary" : "btn-dark"
                        }`}
                        onClick={() => setActiveTab("group")}
                    >
                        Groups 
                    </button>
                </div>

                {activeTab === "individual" ? (
                    <>
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search individuals, organisation, email, or group"
                                value={searchIndividuals}
                                onChange={(e) => setSearchIndividuals(e.target.value)}
                            />
                        </div>

                        <div className="mb-3 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary me-2"
                                onClick={handleSelectAllIndividuals}
                                disabled={
                                    filteredIndividuals.length === 0 ||
                                    // Check if all visible items are already selected
                                    filteredIndividuals.every(p => individualSelected.includes(p._id))
                                }
                            >
                                Select All
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={handleDeselectAllIndividuals}
                                // Only disable if none of the visible items are selected
                                disabled={
                                    filteredIndividuals.length === 0 ||
                                    filteredIndividuals.every(p => !individualSelected.includes(p._id))
                                }
                            >
                                Deselect All
                            </button>
                        </div>

                        <div
                            className="table-responsive individuals-list mb-3"
                            style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ width: "5%" }}>Select</th>
                                        <th style={{ width: "30%" }}>Name</th>
                                        <th style={{ width: "35%" }}>Email</th>
                                        <th style={{ width: "30%" }}>Group(s)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredIndividuals.length > 0 ? (
                                        filteredIndividuals.map((p) => (
                                            <tr key={p._id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={individualSelected.includes(p._id)}
                                                        onChange={() =>
                                                            handleIndividualCheckboxChange(p._id)
                                                        }
                                                    />
                                                </td>
                                                <td>{p.fullName}</td>
                                                <td>{p.email}</td>
                                                <td>{p.group}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center text-muted"
                                            >
                                                No individuals found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    // 🌟 MODIFIED GROUPS TAB JSX - Now displays flat list of individuals in groups
                    <>
                        {/* SEARCH BAR */}
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                // Search field now looks for individuals, email, or the group name/string
                                placeholder="Search individuals, organisation email, or group"
                                value={searchGroups}
                                onChange={(e) => setSearchGroups(e.target.value)}
                            />
                        </div>

                        {/* GROUP ACTION BUTTONS */}
                        <div className="mb-3 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary me-2"
                                onClick={handleSelectAllGroups}
                                disabled={
                                    filteredGroupMembersList.length === 0 ||
                                    // Check if all visible items are already selected
                                    filteredGroupMembersList.every(p => groupMembersSelected.includes(p._id))
                                }
                            >
                                Select All
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={handleDeselectAllGroups}
                                // Only disable if none of the visible items are selected
                                disabled={
                                    filteredGroupMembersList.length === 0 ||
                                    filteredGroupMembersList.every(p => !groupMembersSelected.includes(p._id))
                                }
                            >
                                Deselect All
                            </button>
                        </div>

                        <div
                            className="table-responsive individuals-list mb-3"
                            style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                            <table className="table table-striped table-hover">
                                <thead>
                                    {/* Headers match the Individuals tab */}
                                    <tr>
                                        <th style={{ width: "5%" }}>Select</th>
                                        <th style={{ width: "30%" }}>Name</th>
                                        <th style={{ width: "35%" }}>Email</th>
                                        <th style={{ width: "30%" }}>Group(s)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredGroupMembersList.length > 0 ? (
                                        filteredGroupMembersList.map((p) => (
                                            <tr key={p._id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={groupMembersSelected.includes(p._id)}
                                                        // Use the group member handler
                                                        onChange={() =>
                                                            handleGroupMemberChange(p._id)
                                                        } 
                                                    />
                                                </td>
                                                <td>{p.fullName}</td>
                                                <td>{p.email}</td>
                                                <td>{p.group}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center text-muted"
                                            >
                                                No group members found matching your search.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

                <div className="action-buttons mt-3">
                    <button
                        type="button"
                        className="btn btn-outline-secondary me-2"
                        onClick={() => {
                            setIndividualSelected([]);
                            setGroupSelected({});
                            setGroupMembersSelected([]);
                            setSelectedTemplate("");
                            setEditorHtml("");
                            setFormData(prev => ({ ...prev, subject: "" })); // Clear subject as well
                        }}
                    >
                        Cancel
                    </button>
                    <button 
                        type="submit" 
                        className="btn btn-secondary"
                        disabled={selectedRecipientCount === 0 || !formData.subject || !editorHtml}
                    >
                        Send Email 
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SendEmails;